import React, { useContext, memo } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { Link, useLocation } from 'react-router-dom';
import { TabAnchor } from '../../product-tabs/types';

const LinkToReviewsComponent: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<ILinkToReviewsProps>
>> = ({ children, onClick }) => {
  const location = useLocation();
  const { t } = useContext(AppContext);
  const to = `${location.pathname}${location.search}${TabAnchor.REVIEWS}`;

  return (
    <Link to={to} onClick={onClick} aria-label={t('product', 'tabs.reviews')}>
      {children}
    </Link>
  );
};

interface ILinkToReviewsProps {
  onClick?: (ev: React.MouseEvent) => void;
  children: React.ReactNode | null;
}

export const LinkToReviews = memo(LinkToReviewsComponent);
